@if(bookingDetailsViewModel$ |async; as bookingDetailsViewModel){
<main class="main-content">
  <vy-breadcrumb [items]="bookingDetailsViewModel.breadcrumbItems"></vy-breadcrumb>
  <section class="main-section">
    <div #tripInfoHeader>
      <app-flight-summary-header
        [recordLocator]="bookingDetailsViewModel.recordLocator"
        [paxAmount]="bookingDetailsViewModel.bookingDetails.paxAmount"
        [status]="bookingDetailsViewModel.bookingDetails.pnrStatus"
        [channel]="bookingDetailsViewModel.bookingDetails.channel"
        [gdsRecordLocator]="bookingDetailsViewModel.bookingDetails.gdsRecordLocator"
      ></app-flight-summary-header>

      @if(alertConfig().enabled){
      <div class="marginBottom-xl">
        <vy-alert-message
          [type]="alertConfig().type"
          [size]="alertConfig().size"
          [labelButton]="alertConfig().labelButton"
          [buttonLink]="alertConfig().buttonLink"
          [attrTypeButton]="alertConfig().attrTypeButton"
          [messageButtonInline]="alertConfig().marginBottom"
          [message]="alertConfig().message"
        ></vy-alert-message>
      </div>

      } @if(bookingDetailsViewModel.areJourneyDetailsAllowed){
      <app-flight-journeys-summary
        [flightJourneysData]="bookingDetailsViewModel.bookingDetails.flightJourneys"
        [stations]="bookingDetailsViewModel.stations"
        [paxAmount]="bookingDetailsViewModel.bookingDetails.paxAmount"
      ></app-flight-journeys-summary>
      }
    </div>
    <app-pax-services-and-contact-information
      [sharedBookingServices]="bookingDetailsViewModel.bookingDetails.otherServices"
      [paymentDetails]="bookingDetailsViewModel.bookingDetails.paymentDetails"
      [passengerServices]="bookingDetailsViewModel.bookingDetails.servicesPerPassenger"
      [contactInformationAgency]="bookingDetailsViewModel.bookingDetails.agencyContactInformation!"
      [contactInformationPrimary]="bookingDetailsViewModel.bookingDetails.paxContactInformation!"
      [currencyCode]="bookingDetailsViewModel.currencyCode"
      [itineraryType]="bookingDetailsViewModel.itineraryType"
      [stations]="bookingDetailsViewModel.stations"
      [flightJourneys]="bookingDetailsViewModel.bookingDetails.flightJourneys"
      [recordLocator]="bookingDetailsViewModel.recordLocator"
    ></app-pax-services-and-contact-information>

    @if(bookingDetailsViewModel.areOtherManagementOptionsAllowed){
    <h2 class="headingXL marginBottom-m">
      {{'booking_details_component.other_management_options_component.title' | translate}}
    </h2>
    <div class="vy-card-image_wrapper marginBottom-l">
      @for(featureCard of bookingDetailsViewModel.featuredCards; track featureCard){ @if (featureCard.isAllowed) {
      <div class="vy-card-image_content">
        <vy-card-featured
          [cardFeaturedInfo]="featureCard"
          (clickEventEmitter)="handleCardClick($event)"
        ></vy-card-featured>
      </div>
      } }
    </div>
    } @if(bookingDetailsViewModel.areImproveTripOptionsAllowed){
    <h2 class="headingXL marginBottom-m">{{'booking_details_component.improve_trip_component.title' | translate}}</h2>
    <div class="vy-card-image_wrapper marginBottom-m">
      <div class="vy-card-image_content">
        <vy-card-quick-access
          [type]="cardsQuickAccessType"
          [title]="'booking_details_component.improve_trip_component.add_bags'"
          [icon]="'ds-icon-checked-bag'"
          (click)="handleQuickCardClick(currentRedirectRoutes.AddBags)"
        ></vy-card-quick-access>
      </div>
    </div>
    @if (!bookingDetailsViewModel.hasGcbg) {
    <div class="vy-card-image_wrapper marginBottom-m">
      <div class="vy-card-image_content">
        <vy-card-quick-access
          [type]="cardsQuickAccessType"
          [title]="'booking_details_component.improve_trip_component.add_hand_luggage'"
          [icon]="'ds-icon-2-handbag-large'"
          (click)="handleQuickCardClick(currentRedirectRoutes.CabinBag)"
        ></vy-card-quick-access>
      </div>
    </div>
    }
    <div class="vy-card-image_wrapper marginBottom-m">
      <div class="vy-card-image_content">
        <vy-card-quick-access
          [type]="cardsQuickAccessType"
          [title]="'booking_details_component.improve_trip_component.add_special_luggage'"
          [icon]="'ds-icon-golf'"
          (click)="handleQuickCardClick(currentRedirectRoutes.SpecialEquipment)"
        ></vy-card-quick-access>
      </div>
    </div>
    } @if(bookingDetailsViewModel.bookingDetails.pnrStatus === 'PendingProcess'){
    <vy-button
      (click)="handlePendingProcessClick()"
      onkeypress="handlePendingProcessClick()"
      [label]="'booking_details_component.buttons.view_booking'"
      [fullWidth]="false"
      [isLoading]="false"
      [iconRight]="'ds-icon-arrow-right'"
      class="align-center"
    ></vy-button>
    }
  </section>
</main>
}
